import { RowAdministratorProjectDto } from "@/dtos";
import { AdministratorProject } from "@/entities";

export const formatRowAdministratorProjectDto = (administratorProjects: AdministratorProject[]): RowAdministratorProjectDto[] => {
    return administratorProjects.map(x => {
        const row: RowAdministratorProjectDto = {
            ...x,
            project: x.detail.project,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}